import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import { BsHddNetwork } from "react-icons/bs";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiJava,
  DiDocker,
} from "react-icons/di";
import {
  SiPostgresql,
  SiNextdotjs,
  SiCsharp,
  SiPowershell,
  SiExpress,
  SiAmazonec2,
  SiApachekafka,
  SiSpringboot,
  SiLinux,
} from "react-icons/si";

const stack = [
  { icon: <DiJava />, name: "Java" },
  { icon: <DiPython />, name: "Python" },
  { icon: <DiJavascript1 />, name: "JavaScript" },
  { icon: <CgCPlusPlus />, name: "C++" },
  { icon: <SiCsharp />, name: "C#" },
  { icon: <SiPowershell />, name: "PowerShell" },
  { icon: <SiSpringboot />, name: "Spring Boot" },
  { icon: <DiNodejs />, name: "Node.js" },
  { icon: <DiReact />, name: "React" },
  { icon: <SiNextdotjs />, name: "Next.js" },
  { icon: <SiExpress />, name: "Express" },
  { icon: <SiApachekafka />, name: "Kafka" },
  { icon: <BsHddNetwork />, name: "gRPC" },
  { icon: <SiPostgresql />, name: "PostgreSQL" },
  { icon: <DiMongodb />, name: "MongoDB" },
  { icon: <DiDocker />, name: "Docker" },
  { icon: <SiLinux />, name: "Linux" },
  { icon: <SiAmazonec2 />, name: "AWS" },
];

function Techstack() {
  return (
    <Row className="g-3 justify-content-center" style={{ paddingBottom: "50px" }}>
      {stack.map((tech) => (
        <Col xs={6} md={4} lg={3} key={tech.name}>
          <div className="tech-icons tech-icons-labeled">
            <div>{tech.icon}</div>
            <p className="tech-icon-label">{tech.name}</p>
          </div>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
